import { DevMocks, NO_DEV_MOCKS } from './devMocksTypes'
import { areDevToolsAvailable } from './devToolsAvailability'

/** Its own key, so mocks stay independent of the LaunchDarkly override store. */
export const DEV_MOCKS_STORAGE_KEY = 'devMocks'

export const readDevMocks = (): DevMocks => {
  try {
    const stored = localStorage.getItem(DEV_MOCKS_STORAGE_KEY)
    if (!stored) {
      return NO_DEV_MOCKS
    }
    const parsed = JSON.parse(stored) as Partial<DevMocks>
    return { npTestPlan: { ...NO_DEV_MOCKS.npTestPlan, ...parsed.npTestPlan } }
  } catch {
    return NO_DEV_MOCKS
  }
}

/** For readers outside React, such as RTK Query endpoints. Never returns stored mocks in production. */
export const readActiveDevMocks = (): DevMocks => (areDevToolsAvailable() ? readDevMocks() : NO_DEV_MOCKS)

export const writeDevMocks = (mocks: DevMocks) => localStorage.setItem(DEV_MOCKS_STORAGE_KEY, JSON.stringify(mocks))

export const clearStoredDevMocks = () => localStorage.removeItem(DEV_MOCKS_STORAGE_KEY)
